<template lang="pug">
v-row(class="tw-pt-1 tw-bord  tw-pl-4 ")
  v-col(class=" tw-border-gray-lighten-2 tw-border-solid tw-border-1 tw-bg-white tw-rounded-md tw-mt-4")
    span(class=" tw-font-bold tw-text-lg tw-capitalize") {{ $t('Listings.Common.filters') }}
    v-row(justify="center")
      v-col(cols="11")
        v-row(class="")
          v-col(class="tw-mt-1" cols="12")
            span(class="tw-capitalize") {{ $t('Listings.Common.price') }}
            v-range-slider(
              v-model="price"
              @change="search"
              :step="price_steps"
              :min="price_min"
              :max="price_max"
              hide-details
            )
            div
              v-row(no-gutters class="")
                v-col
                  span {{ price[0] }}
                v-col(class="tw-text-right")
                  span {{ price[1] }}
        v-row
          v-col
            v-expansion-panels(
              v-model="panel"
              tile
              flat
              accordion
              multiple
              active-class="filters-active"
            )
              v-expansion-panel
                v-expansion-panel-header
                  span(class="tw--mx-5 tw-capitalize") {{ $t('Listings.Common.transaction') }}
                v-expansion-panel-content(class="!tw-p-0")
                  v-radio-group(v-model="transaction" column dense class="ma-0 pa-0")
                    v-radio(:label="$t('Common.all')" value="all" @click="search" active-class="k-radio-active")
                    v-radio(
                      :label="$t('Listings.Common.forSale')"
                      value="sale"
                      @click="search"
                      active-class="k-radio-active"
                      class="tw-capitalize"
                    )
                    v-radio(
                      :label="$t('Listings.Common.forRent')"
                      value="rent"
                      @click="search"
                      active-class="k-radio-active"
                      class="tw-capitalize"
                    )
              v-expansion-panel
                v-expansion-panel-header
                  span(class="tw--mx-5 tw-capitalize") {{ $t('Listings.Common.propertyType') }}
                v-expansion-panel-content(class="!tw-p-0")
                  v-checkbox(
                    hide-details
                    v-model="type"
                    value="1"
                    @click="search"
                    :label="$t('Listings.Common.house')"
                    class=" pa-0 ma-0 pb-1 pl--2 tw-capitalize"
                  )
                  v-checkbox(
                    hide-details
                    v-model="type"
                    value="2"
                    @click="search"
                    :label="$t('Listings.Common.appartment')"
                    class=" pa-0 ma-0 pb-1 pl--2 tw-capitalize"
                  )
                  v-checkbox(
                    hide-details
                    v-model="type"
                    value="3"
                    @click="search"
                    :label="$t('Listings.Common.office')"
                    class=" pa-0 ma-0 pb-1 pl--2 tw-capitalize"
                  )
                  v-checkbox(
                    hide-details
                    v-model="type"
                    value="4"
                    @click="search"
                    :label="$t('Listings.Common.commercial')"
                    class=" pa-0 ma-0 pb-1 pl--2 tw-capitalize"
                  )
                  v-checkbox(
                    hide-details
                    v-model="type"
                    value="5"
                    @click="search"
                    :label="$t('Listings.Common.plot')"
                    class=" pa-0 ma-0 pb-1 pl--2 tw-capitalize"
                  )
              v-expansion-panel
                v-expansion-panel-header
                  span(class="tw--mx-5 tw-capitalize") {{ $t('Listings.Common.bedrooms') }}
                v-expansion-panel-content(class="!tw-p-0")
                  v-checkbox(
                    hide-details
                    v-model="bedrooms"
                    value="1"
                    @click="search"
                    label="1"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
                  v-checkbox(
                    hide-details
                    v-model="bedrooms"
                    value="2"
                    @click="search"
                    label="2"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
                  v-checkbox(
                    hide-details
                    v-model="bedrooms"
                    value="3"
                    @click="search"
                    label="3"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
                  v-checkbox(
                    hide-details
                    v-model="bedrooms"
                    value=">=4"
                    @click="search"
                    :label="'4 ' + $t('Listings.Common.orMore')"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
              v-expansion-panel
                v-expansion-panel-header
                  span(class="tw--mx-5 tw-capitalize") Bathrooms
                v-expansion-panel-content(class="!tw-p-0")
                  v-checkbox(
                    hide-details
                    v-model="bathrooms"
                    value="1"
                    @click="search"
                    label="1"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
                  v-checkbox(
                    hide-details
                    v-model="bathrooms"
                    value="2"
                    @click="search"
                    label="2"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
                  v-checkbox(
                    hide-details
                    v-model="bathrooms"
                    value="3"
                    @click="search"
                    label="3"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
                  v-checkbox(
                    hide-details
                    v-model="bathrooms"
                    value=">=4"
                    @click="search"
                    :label="'4 ' + $t('Listings.Common.orMore')"
                    class=" pa-0 ma-0 pb-1 pl--2"
                  )
</template>
<script>
export default {
  data() {
    return {
      panel: this.$vuetify.breakpoint.mobile ? [] : [0, 1, 2, 3],
      type: [],
      bedrooms: [],
      bathrooms: [],
      price: [5000, 100000],
      price_min: 5000,
      price_max: 100000,
      price_steps: 5000,
      transaction: 'all',
    };
  },
  computed: {
    query() {
      if (this.$store.getters['properties/query']) {
        return this.$store.getters['properties/query'];
      } else {
        return new URLSearchParams();
      }
    },
  },
  methods: {
    search() {
      if (this.type) {
        this.query.delete('type');
        if (this.type.length > 0) {
          this.query.append('type', this.type.join(' OR '));
        }
      }

      if (this.bedrooms) {
        this.query.delete('bedrooms');
        if (this.bedrooms.length > 0) {
          this.query.append('bedrooms', this.bedrooms.join(' OR '));
        }
      }

      if (this.bathrooms) {
        this.query.delete('bathrooms');
        if (this.bathrooms.length > 0) {
          this.query.append('bathrooms', this.bathrooms.join(' OR '));
        }
      }

      if (this.transaction && this.transaction === 'all') {
        this.query.delete('rent_enabled');
        this.query.delete('sale_enabled');
      }

      if (this.transaction && this.transaction === 'rent') {
        this.query.delete('rent_enabled');
        this.query.delete('sale_enabled');
        this.query.append('rent_enabled', 1);
      }

      if (this.transaction && this.transaction === 'sale') {
        this.query.delete('sale_enabled');
        this.query.delete('rent_enabled');
        this.query.append('sale_enabled', 1);
      }

      if (this.price[0] || this.price[1]) {
        this.query.delete('price_min');
        this.query.delete('price_max');
        if (this.price[0] - 5000 >= this.price_min) {
          this.query.append('price_min', this.price[0]);
        }
        if (this.price[1] + 5000 <= this.price_max) {
          this.query.append('price_max', this.price[1]);
        }
      }

      this.$store.dispatch('properties/search', this.query);
    },
  },
};
</script>
<style>
.filters-active .v-expansion-panel-content__wrap {
  padding: 0 10px 10px;
}
.k-radio-active {
  background-color: #fff;
}
</style>
